module.exports = __webpack_public_path__ + "static/assets/bf0e25ec9be689221c5de3acfd2fa98d.png";